import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class InvoiceSaleService {
	private URL = environment.api;

	getUrlApi() {
		return this.URL;
	}

	constructor(private http: HttpClient) { }

	getProducts(input: string) {
		return this.http.get(this.URL + "api/erp/inventory/product/search/existing",
			{
				params: {
					clue: input,
					bought: false,
					sold: true
				}
			}
		);
	}

	getProductsFilteredByFavorite(input: string, warehouseId?: number | null) {
		const params: any = {
			clue: input,
			bought: false,
			sold: true
		};

		if (warehouseId != null) {
			params.warehouse = warehouseId;
		}

		return this.http.get(
			this.URL + "api/erp/inventory/product/search/existing",
			{ params }
		);
	}

	getProductsPurchases(input: string) {
		return this.http.get(this.URL + "api/erp/inventory/product/search/existing",
			{
				params: {
					clue: input,
					bought: true,
					sold: false
				}
			}
		);
	}

	getAllProducts(input: string) {
		return this.http.get(this.URL + "api/erp/inventory/product/search/existing",
			{
				params: {
					clue: input,
					bought: true,
					sold: true
				}
			}
		);
	}

	getInvoiceBag(startDate: number, endDate: number) {
		return this.http.get(this.URL + `api/erp/sale/invoices/clientBackend`, {
			params: {
				startDate: startDate,
				endDate: endDate
			}
		});
	}

	removeClientBackendInvoice(invoiceId: number) {
		return this.http.put(this.URL + "api/erp/sale/invoices/rollback/" + invoiceId, {});
	}

	anulateClientBackendInvoice(invoiceId: number) {
		return this.http.put(this.URL + "api/erp/sale/invoices/rollbackOut/" + invoiceId, {});
	}

	getClients() {
		return this.http.get(this.URL + "api/erp/inventory/vendor/search/existing",
			{
				params: {
					clue: '',
					client: true,
					provider: false
				}
			}
		);
	}

	getClientsByClue(clue: string) {
		return this.http.get(this.URL + "api/erp/inventory/vendor/search/existing",
			{
				params: {
					clue: clue,
					client: true,
					provider: false
				}
			}
		);
	}

	getClientsByPlace(place: any) {
		return this.http.get(this.URL + "api/erp/inventory/vendor/search/existing/place",
			{
				params: {
					clue: '',
					client: true,
					provider: false,
					place: place
				}
			}
		);
	}

	getClientsByClueByPlace(clue: string, place: any) {
		return this.http.get(this.URL + "api/erp/inventory/vendor/search/existing/place",
			{
				params: {
					clue: clue,
					client: true,
					provider: false,
					place: place
				}
			}
		);
	}

	getWarehouses() {
		return this.http.get(this.URL + "api/erp/inventory/warehouse/search/existing",
			{
				params: {
					clue: ''
				}
			}
		);
	}

	getWarehouseByClue(clue: any) {
		return this.http.get(this.URL + "api/erp/inventory/warehouse/search/existing", {
			params: {
				clue: clue
			}
		});
	}
	/**
	 * 
	 * @returns 
	 */
	getCash() {
		return this.http.get(this.URL + "api/erp/sale/invoices/cash/search",
			{
				params: {
					clue: ''
				}
			}
		);
	}

	/**
	 * Function that sends an HTTP GET request to a API in order to retrieve information about the type of payments of the user.
	 * @returns An observable object that represents the HTTP GET request, includes the payment types
	 */
	getPaymentTypes() {
		return this.http.get(this.URL + 'api/erp/purchase/invoices/payment/types');
	}

	/**
	 * Function that sends an HTTP GET request to a specified URL in order to retrieve information about the existence or inventory status of a product in a particular warehouse.
	 * @param warehouseId An integer representing the unique identifier of the warehouse for which you want to check product existence. 
	 * @param productId An integer representing the unique identifier of the product whose existence you want to check.
	 * @returns An observable object that represents the HTTP GET request, that includes the number of existences on warehouse of the product in the attribute data.
	 */
	getExistence(warehouseId: number, productId: number) {
		return this.http.get(this.URL + 'api/erp/inventory/product/existence/' + warehouseId + '/' + productId);
	}

	/**
	 * Function that sends an HTTP GET request to a specified URL in order to retrieve information about the existence or inventory status
	 * plus recipe ingredients if is product virtual
	 * of a product in a particular warehouse.
	 * @param warehouseId An integer representing the unique identifier of the warehouse for which you want to check product existence. 
	 * @param productId An integer representing the unique identifier of the product whose existence you want to check.
	 * @returns An observable object that represents the HTTP GET request, that includes the number of existences on warehouse of the product in the attribute data.
	 */
	getExistencePlusRecipe(warehouseId: number, productId: number) {
		return this.http.get(this.URL + 'api/erp/inventory/product/existence-plus-recipe/' + warehouseId + '/' + productId);
	}

	getExistencePlusRecipeOnlyProduct(productId: number) {
		return this.http.get(this.URL + 'api/erp/inventory/product/existence-plus-recipe/' + productId);
	}

	/**
	 * Function that sends an HTTP GET request to the api in order to retrieve information about the banks of the user.
	 * @returns An observable object that represents the HTTP GET request, that includes the list of the banks
	 */
	getBanks() {
		return this.http.get(this.URL + "api/bank/all");
	}

	/**
	 * Function that sends an HTTP GET request to the api in order to retrieve the list of orders
	 * @returns An observable object that represents the HTTP GET request, that includes a list of orders active
	 */
	getAllOrders() {
		return this.http.get(this.URL + "api/erp/sale/orders/active");
	}

	/**
	 * Function that sends an HTTP GET request to the api in order to retrieve the list of products of the order
	 * @param orderId An number that represents the id of the selected order
	 * @returns A list of products of the specified order
	 */
	getDetailOrder(orderId: number) {
		return this.http.get(this.URL + 'api/erp/sale/orders/detail/' + orderId);
	}

	/**
	 * Function that sends an HTTP GET request to the api in order to retrieve the list of active accounts of the company
	 * @returns An observable object, that includes data about the bank active accounts
	 */
	getBankActiveAccounts() {
		return this.http.get(this.URL + 'api/erp/bank/accounts?active=true');
	}

	/**
	 * Function that sends an HTTP GET request to the api in order to retrieve the price of the product
	 * @param productId An number, that represents the id of the product
	 * @param warehouseId An number, that represents the id of the warehouse
	 * @returns An observable object, that includes data about the price of the product
	 */
	getPrice(productId: number, warehouseId: number) {
		return this.http.get(this.URL + 'api/erp/inventory/product/prices/' + warehouseId + '/' + productId);
	}

	/**
	 * Function that sends an HTTP GET request to the api in order to retrieve the price of the product filtered
	 * @param productId An number, that represents the id of the product
	 * @param warehouseId An number, that represents the id of the warehouse
	 * @returns An observable object, that includes data about the price of the product
	 */
	getPriceFiltered(productId: number, warehouseId: number) {
		return this.http.get(this.URL + 'api/erp/inventory/product/prices-filtered/' + warehouseId + '/' + productId);
	}

	getPriceFilteredDestination(productId: number, warehouseId: number) {
		return this.http.get(this.URL + 'api/erp/inventory/product/prices-filtered-destination/' + warehouseId + '/' + productId);
	}

	getPriceFilteredPlace(productId: number, warehouseId: number) {
		return this.http.get(this.URL + 'api/erp/inventory/product/prices-filtered-place/' + warehouseId + '/' + productId);
	}

	/**
	 * Function that sends an HTTP GET request to the api in order to retrieve the price of the product
	 * @param productId An number, that represents the id of the product
	 * @param clientId An number, that represents the id of the client
	 * @returns An observable object, that includes data about the price of the product
	getPriceOriginal(productId: number, clientId: number) {
		return this.http.get(this.URL + "api/erp/inventory/product/price/" + productId + "/" + clientId);
	}
	*/

	/**
	 * Function that sends an HTTP GET request to the api in order to retrieve the price lists of the product
	 * @param productId An number, that represents the id of the product
	 * @returns An observable object, that includes data about the price of the product
	 */
	getPriceLists(productId: number) {
		return this.http.get(this.URL + "api/erp/inventory/product/price/" + productId);
	}

	getTypesdoc(warehouseId: number) {
		return this.http.get(this.URL + "api/erp/sale/invoices/typesdoc?wharehouseId=" + warehouseId);
	}

	/**
	 * Function that sends an HTTP GET request to the api in order to retrieve the card types
	 * @returns An observable object that includes data about the card types
	 */
	getCardTypes() {
		return this.http.get(this.URL + "api/erp/sale/invoices/card/types");
	}

	saveInvoice(invoice: any) {
		return this.http.post(this.URL + "api/erp/sale/invoices", invoice);
	}

	saveQuotation(invoice: any) {
		return this.http.post(this.URL + "api/erp/sale/invoices/prices", invoice);
	}

	validateAffiliate(clientId: number) {
		return this.http.get(this.URL + "api/erp/affiliate/isAffiliate/" + clientId);
	}

	getAffiliateByClue(clue: string) {
		return this.http.get(this.URL + "api/erp/affiliate/search/existing", {
			params: {
				clue: clue
			}
		});
	}

	getAffiliatePointsByVendorId(vendorId: any) {
		return this.http.get(this.URL + "api/erp/affiliate/points/"+vendorId);
	}

	getValueDolarXML() {
		const soapRequest = `<soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/MLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
							  <soap:Body>
								<TipoCambioDia xmlns="http://www.banguat.gob.gt/variables/ws/" />
							  </soap:Body>
							</soap:Envelope>`;

		const headers = { 'Content-Type': 'text/xml; charset=utf-8' };

		return this.http.post('http://www.banguat.gob.gt/variables/ws/TipoCambio.asmx', soapRequest, { headers, responseType: 'text' });
	}

	downloadPdf(pdfUrl: string) {
		return this.http.get(pdfUrl, { responseType: 'arraybuffer' });
	}

	getRTUDataByNit(nit: string) {
		return this.http.post('https://edxgtupdate20.azurewebsites.net/api/GetRTUData', { "nit": nit });
	}

	getRTUDataByCui(cui: string) {
		return this.http.get('http://edxgt.server.edxsolutions.com/API.CUI/RequestCUI/' + cui);
	}

	getClientsByNit(clue: string) {
		return this.http.get(this.URL + "api/erp/inventory/vendor/search/exact",
			{
				params: {
					nit: clue
				}
			}
		);
	}

	getProvidersByNit(clue: string) {
		return this.http.get(this.URL + "api/erp/inventory/vendor/search/provider-inventories/exact",
			{
				params: {
					nit: clue
				}
			}
		);
	}

	getTypesDoc(warehouseId) {
		return this.http.get(this.URL + "api/erp/sale/invoices/typesdoc", {
			params: {
				warehouseId: warehouseId
			}
		})
	}

	//https://app.dev.servicios.gt/api/erp/inventory/vendor/search/existing/banks?client=true&clue=empr&company=809&onlyActive=true&provider=false
	//https://app.dev.servicios.gt/api/erp/inventory/vendor/search/existing/banks?client=false&clue=empr&company=809&onlyActive=true&provider=true
	getClientsOrProvidersForBank(clue: string, company, isClient = true) {
		const headerDict = {
			"inin-company": company
		}
		const requestOptions = {
			headers: new HttpHeaders(headerDict), 
			params: {
				clue: clue,
				client: isClient,
				provider: !isClient,
				company: company,
				onlyActive: true
			}
		};
		return this.http.get(this.URL + "api/erp/inventory/vendor/search/existing/banks",
			requestOptions
		);
	}

	deleteDuplicatedInvoices(companyId: number, startDate: number, endDate: number) {
		return this.http.delete<any>(`${this.URL}api/erp/sale/invoices/delete-duplicated/${companyId}`, {
			params: {
				startDate: startDate.toString(),
				endDate: endDate.toString()
			}
		});
	}

	getClientCredit(vendorId: number) {
		return this.http.get<any>(`${this.URL}api/erp/inventory/vendor/related-credit/${vendorId}`, {
		});
	}

	getLastInvoicesClientDays() {
		return this.http.get<any>(`${this.URL}api/erp/sale/invoices/last-invoices-clients-days`);
	}

	getProductsFavorite(clue: string, warehouseId: number) {
		return this.http.get(
			`${this.URL}/product/favorites/${warehouseId}?clue=${encodeURIComponent(clue || '')}`
		);
	}

	postCreateAdvacenPayment(data: any) {
		return this.http.post(this.URL + "api/erp/bank/all-advance", data);
	}
}